export default defineNuxtRouteMiddleware((to, _from) => {
  const layouts = ["public"];
  const exclusions = ["login"];
  let layout = "default";
  const regExp = /[^/\\]+/;
  const found = to.fullPath.match(regExp)?.toString() ?? "";
  if (layouts.includes(found)) {
    layout = found;
  }
  if (!exclusions.includes(found)) {
    to.meta.layout = layout;
  }
});
